module.exports = __webpack_public_path__ + "img/icon40.2afb4d32.png";